import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Button } from 'reactstrap';
import Icon from '@availity/icon';
var btnStyles = {
  fontSize: '1.4em',
  padding: '.2em .4em'
};

var FeedbackButton = function FeedbackButton(_ref) {
  var _onClick = _ref.onClick,
      icon = _ref.icon,
      active = _ref.active,
      children = _ref.children,
      iconSize = _ref.iconSize,
      rest = _objectWithoutPropertiesLoose(_ref, ["onClick", "icon", "active", "children", "iconSize"]);

  return React.createElement(Button, Object.assign({
    style: btnStyles,
    color: active === icon ? 'primary' : 'light',
    onClick: function onClick() {
      return _onClick(icon);
    }
  }, rest), React.createElement(Icon, {
    "data-testid": "feedback-icon",
    name: icon,
    size: iconSize
  }), React.createElement("span", {
    className: "sr-only"
  }, children));
};

FeedbackButton.defaultProps = {
  iconSize: ''
};
export default FeedbackButton;